import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-icon-button', // Selector for the button component
    templateUrl: './icon-button.component.html', // Template file for the button component
    styleUrls: ['./icon-button.component.scss'] // Corrected to 'styleUrls' for consistency with Angular documentation
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconButtonComponent {
  @Input() label: string = 'Button'; // Button label text
  @Input() type: 'button' | 'submit' | 'reset' = 'button'; // Button type attribute
  @Input() color: string = 'bg-primary hover:bg-white'; // Background color classes for the button
  @Input() borderColor: string = 'border-primary'; // Border color classes for the button
  @Input() customClass: string = ''; // Any additional custom classes to apply to the button
  @Input() iconCustomClass: string = ''; // Any additional custom classes to apply to the button
  @Output() onClick = new EventEmitter<void>(); // Event emitter for click events
  @Input() look: 'primary' | 'secondary' | 'clear' | 'danger' = 'primary'; // Button look style
  @Input() size: 'small' | 'medium' | 'large' = 'medium'; // Button size
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() iconTemplate: TemplateRef<any> | null;


  /**
   * Handles the button click event and emits the onClick event.
   */
  handleClick() {
    if (!this.disabled) {
      this.onClick.emit(); // Emit the click event to the parent component
    }
  }

  getButtonClasses(): { [key: string]: boolean } {
    return {
      [this.borderColor]: !!this.borderColor,
      [this.customClass]: !!this.customClass,
      'bg-grey-200 opacity-90': this.disabled,
      'bg-primary': this.look === 'primary' && !this.disabled,
      'text-white': (this.look === 'primary' || this.look === 'secondary' || this.look === 'danger') || this.disabled,
      'text-gray-500': this.look === 'clear' && !this.disabled,
      'border-gray-500': (this.look === 'clear' || this.look === 'primary') && !this.disabled,
      'bg-secondary': this.look === 'secondary' && !this.disabled,
      'bg-red-500': this.look === 'danger' && !this.disabled,
      'border-red-500': this.look === 'danger' && !this.disabled,
      'hover:bg-primary-700': this.look === 'primary' && !this.disabled,
      'hover:bg-red-700': this.look === 'danger' && !this.disabled,
      'hover:bg-secondary-700': this.look === 'secondary' && !this.disabled,
      'active:bg-primary-800': this.look === 'primary' && !this.disabled,
      'active:bg-red-800': this.look === 'danger' && !this.disabled,
      'active:bg-secondary-800': this.look === 'secondary' && !this.disabled,
      'active:bg-gray-600': this.look === 'clear' && !this.disabled,
      'active:text-white': this.look === 'clear' && !this.disabled,
    };
  }
}
